module.exports = __webpack_public_path__ + "img/banner-forecast.34fcf90b.jpg";